<template>
    <div>
    <nav class="navbar navbar-expand-lg navbar-light  shadow" id="mainNav">
      <div class="container px-4 px-lg-5">
          <a class="navbar-brand" href="index.html"><img src="../assets/webitscure-logo.png" class="img-fluid brand" alt=""></a>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavId" aria-controls="collapsibleNavId"
          aria-expanded="false" aria-label="Toggle navigation">
              <i class="fas fa-bars"></i>
          </button>
          <div class="collapse navbar-collapse" id="collapsibleNavId">
              <ul class="navbar-nav ms-auto py-4 py-lg-0">
                  <li class="nav-item"><a class="nav-link px-lg-3 py-3 py-lg-4" href="index.html">Pricing</a></li>
                  <li class="nav-item"><a class="nav-link px-lg-3 py-3 py-lg-4" href="about.html">Product</a></li>
                  <li class="nav-item"><a class="nav-link px-lg-3 py-3 py-lg-4" href="post.html">Solutions</a></li>
                  <li class="nav-item"><a class="nav-link px-lg-3 py-3 py-lg-4" href="contact.html">Enterprice</a></li>
              </ul>
          </div>
      </div>
      </nav>
      <header class="masthead">
        <div class="container position-relative px-4 px-lg-5">
            <div class="row  justify-content-center">
                <div class="col-md-10 col-lg-8 col-xl-7">
                    <div class="site-heading animate__animated animate__fadeInUp">
                        <h1>Turn emails into revenue</h1>
                        <span class="subheading mt-3">Over 1 million businesses rely on webITscure to create and send engaging emails that reach the right people, build better relationships, and help drive revenue and growth. You can too.</span>
                    </div>
                    <div class="text-center mt-5 animate__animated animate__fadeInUp">
                      <button class="btn btn-primary" @click="signup">Signup Now</button>
                    </div>
                </div>
            </div>
        </div>
    </header> 
    </div>
</template>

<script>
export default {
    name : "Nav",
    data:()=>({

    }),
    methods:{
        signup:function(){
            this.$router.push('/signup')
        }
    }
}
</script>
<style lang="css" src="./index/home.css" scoped></style>
<style lang="css" src="../assets/styles.css" scoped></style>